import { render, staticRenderFns } from "./loginVerification-inner-bv.vue?vue&type=template&id=b2c13d32&"
import script from "./loginVerification-inner-bv.vue?vue&type=script&lang=js&"
export * from "./loginVerification-inner-bv.vue?vue&type=script&lang=js&"
import style0 from "./loginVerification-inner-bv.vue?vue&type=style&index=0&id=b2c13d32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports